import { Fragment } from 'react';
import { Avatar, Box, Divider, Typography } from '@mui/material';
import { modules } from '@terraframing-suite/rx-config';
import logo from '../../assets/images/logo-brn.png';
import { useContext } from './context';

const iconSize = 24;

export function SidePanel() {
  const { selectedModules, focusedModule } = useContext();

  return (
    <>
      <Box
        role="side-panel"
        sx={{
          height: '100%',
          width: { md: 200, lg: 250 },
          bgcolor: '#f5f5f5',
          p: { md: 3, lg: 4 },
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
        }}
      >
        <Box component="img" src={logo} sx={{ width: 100 }} />
        {buildTitle()}
        {buildSelectedModules()}
      </Box>
      <Divider orientation="vertical" />
    </>
  );

  function buildTitle() {
    const title = focusedModule
      ? `Run ${modules.find((m) => m.id === focusedModule)?.label} Rx`
      : 'Run Rx';

    return (
      <Typography variant="h6" sx={{ my: 3 }}>
        {title}
      </Typography>
    );
  }

  function buildSelectedModules() {
    return focusedModule ? null : (
      <>
        <Typography variant="caption">
          Select the Rx(s) you wish to run and complete their workflows.
        </Typography>
        <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 1 }}>
          {modules.filter(({ id }) => selectedModules[id]).map(buildModule)}
        </Box>
      </>
    );
  }

  function buildModule(module, index) {
    return (
      <Fragment key={index}>
        {index ? (
          <Divider
            sx={{ height: 7, width: iconSize / 2 }}
            orientation="vertical"
          />
        ) : null}
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <Avatar sx={{ width: iconSize, height: iconSize }}>
            <Typography variant="caption">{index + 1}</Typography>
          </Avatar>
          <Typography variant="body2">{module.label}</Typography>
        </Box>
      </Fragment>
    );
  }
}
